// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Work Sans',
  fonts: [
    { src: 'https://fonts.gstatic.com/s/worksans/v16/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32KxfXNig.ttf', fontWeight: 300 },
    { src: 'https://fonts.gstatic.com/s/worksans/v16/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNig.ttf', fontWeight: 400 },
    { src: 'https://fonts.gstatic.com/s/worksans/v16/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K3vXNig.ttf', fontWeight: 500 },
  ],
});

const styles = StyleSheet.create({
  container: {
    margin: '20px',
  },
  header: {
    height: '30px',
    borderBottom: '1px solid #DCDCDC',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  logo: {
    width: '100px',
    height: '20px',
  },
  name: {
    fontFamily: 'Work Sans',
    marginLeft: '10px',
    fontSize: '10px',
    fontWeight: 400,
    letterSpacing: '4px',
  },
  headerRight: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text1: {
    fontFamily: 'Work Sans',
    fontSize: '10px',
    padding: '1px 0',
    fontWeight: 300,
  },
  text2: {
    fontFamily: 'Work Sans',
    fontSize: '10px',
    padding: '3px 0',
    fontWeight: 500,
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  package: {
    width: '100%',
    paddingRight: '4px',
  },
  title1: {
    fontFamily: 'Work Sans',
    fontSize: '20px',
    fontWeight: 400,
    padding: '8px 0',
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  detailsLeft: {
    width: '60%',
    backgroundColor: '#F8F8F8',
    padding: '10px 20px',
  },
  detailsLeftItemView: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '5px',
  },
  detailsLeftItemLabel: {
    fontFamily: 'Work Sans',
    fontSize: '10px',
    fontWeight: 500,
    padding: '3px 0',
  },
  detailsLeftItemValue: {
    fontFamily: 'Work Sans',
    fontSize: '10px',
    fontWeight: 300,
    padding: '3px 0',
  },
  detailsRight: {
    width: '40%',
    marginLeft: '14px',
    border: '1px solid #ACD2E0',
    backgroundColor: '#01A1DD1A',
  },
  titleContainer: {
    backgroundColor: '#01A1DD',
    color: '#FFFFFF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '50px',
  },
  titleText: {
    fontFamily: 'Work Sans',
    fontSize: '12px',
    fontWeight: 600,
  },
  icon: {
    width: '10px',
    height: '10px',
    marginRight: '5px',
  },
  detailsRightContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px 0',
  },
  creditsUsed: {
    fontFamily: 'Work Sans',
    fontSize: '20px',
    fontWeight: 500,
    color: '#01A1DD',
  },
  fromCredits: {
    fontFamily: 'Work Sans',
    fontSize: '12px',
    fontWeight: 500,
  },
  detailsRightFooter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '10px',
  },
  creditsRemainingValue: {
    fontFamily: 'Work Sans',
    fontSize: '12px',
    fontWeight: 500,
  },
  detailsRightDivider: {
    display: 'flex',
    width: '90%',
    height: '1px',
    backgroundColor: '#DCDCDC',
    margin: '0px auto',
  },
  graphContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
    width: '100%',
  },
  graph: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  graphTitle: {
    fontFamily: 'Work Sans',
    fontSize: '12px',
    fontWeight: 500,
    marginBottom: '10px',
    alignSelf: 'flex-start',
  },
  graphImageContainer: {
    marginBottom: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  graphImage: {
    width: '500px',
    height: '150px',
  },
  calendarImage: {
    width: '500px',
    height: '300px',
  },
});

export default styles;
